import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import Layout from '../../../components/Octopath/layout';
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const SEO = makeShortcode("SEO");
const Menu = makeShortcode("Menu");
const layoutProps = {
  _frontmatter
};

const MDXLayout = ({
  children
}) => <Layout>{children}</Layout>;

export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <SEO title="Octopath Traveler Tressa SS 3 Character w/ Primrose" mdxType="SEO" />
    <blockquote>
      <p parentName="blockquote">{`Note: You can opt into always taking the Outside Morlock Manse battle & picking up the 5k chest there. If you do, you have about $5800 to do with as you please. Notes assume you try to skip the battle & don't get the 5k.`}</p>
    </blockquote>
    <h3 {...{
      "id": "chapter-1"
    }}>{`Chapter 1`}</h3>
    <p>{`Run from Pirate, heal before Mikk & Makk if needed.`}</p>
    <h4 {...{
      "id": "mikk--makk"
    }}>{`Mikk & Makk`}</h4>
    <p>{`T1-3: Tradewinds Mikk`}<br parentName="p"></br>{`
`}{`T4: Tradewinds x4 Mikk (kill)`}<br parentName="p"></br>{`
`}{`T5-6: Tradewinds / Grape`}<br parentName="p"></br>{`
`}{`T7: Tradewinds x4`}<br parentName="p"></br>{`
`}{`T8: Bow`}<br parentName="p"></br>{`
`}{`T9: Defend`}<br parentName="p"></br>{`
`}{`T10: Bow`}<br parentName="p"></br>{`
`}{`T11: Tradewinds x4`}</p>
    <p>{`Head to `}<strong parentName="p">{`Scholar Shrine`}</strong>{`, kill Cait on the way. If you get the Scholar Shrine battle Flee.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "jobs"
      }}>{`Jobs`}</h5>
      <p>{`Hired Help, `}<strong parentName="p">{`Scholar`}</strong>{`, First 2 Skills`}</p>
      <h5 {...{
        "id": "equip-skills"
      }}>{`Equip Skills`}</h5>
      <p>{`Evasive Maneuvers`}</p>
    </Menu>
    <p>{`Go to `}<strong parentName="p">{`Forest of Purgation`}</strong>{`. Pick `}<strong parentName="p">{`Light L`}</strong>{` and `}<strong parentName="p">{`$20000`}</strong>{`.`}</p>
    <p>{`TP `}<strong parentName="p">{`Rippletide`}</strong>{`, go to `}<strong parentName="p">{`North Stonegard Pass`}</strong>{`. Pick `}<strong parentName="p">{`$1200`}</strong>{` on the way.`}</p>
    <p>{`Get `}<strong parentName="p">{`Warrior Shrine`}</strong>{`, go to `}<strong parentName="p">{`Moonstruck Coast`}</strong>{`. S&Q.`}<br parentName="p"></br>{`
`}{`Get `}<strong parentName="p">{`Merchant Shrine`}</strong>{`, Tag Goldshore, Enter `}<strong parentName="p">{`Grandport Coast`}</strong>{`.`}<br parentName="p"></br>{`
`}{`Pick `}<strong parentName="p">{`$20000`}</strong>{`, S&Q, pick `}<strong parentName="p">{`Thunder L`}</strong>{`, enter `}<strong parentName="p">{`Grandport`}</strong>{`.`}</p>
    <p>{`Purchase `}<strong parentName="p">{`Fire M`}</strong>{`, `}<strong parentName="p">{`Ice M`}</strong>{`, and `}<strong parentName="p">{`Wind L`}</strong>{`.`}<br parentName="p"></br>{`
`}{`Pick `}<strong parentName="p">{`Silver-filled Pouch`}</strong>{`, purchase `}<strong parentName="p">{`Pom L`}</strong>{`.`}<br parentName="p"></br>{`
`}{`Pick `}<strong parentName="p">{`Dazzling Artwork`}</strong>{` and `}<strong parentName="p">{`$25000`}</strong>{`.`}</p>
    <p>{`TP `}<strong parentName="p">{`Rippletide`}</strong>{`, run to `}<strong parentName="p">{`Sunshade`}</strong>{`.`}</p>
    <h3 {...{
      "id": "primrose-ch1"
    }}>{`Primrose Ch.1`}</h3>
    <h4 {...{
      "id": "helgenish"
    }}>{`Helgenish`}</h4>
    <p>{`Ice M + Fire M`}</p>
    <h3 {...{
      "id": "ch2-start"
    }}>{`Ch.2 Start`}</h3>
    <p>{`Buy `}<strong parentName="p">{`Thunder L`}</strong>{` and `}<strong parentName="p">{`Thunder M`}</strong>{`. Buy `}<strong parentName="p">{`Shadow M`}</strong>{`, and `}<strong parentName="p">{`Fire M`}</strong>{`. Pick `}<strong parentName="p">{`Fool's Gold Ore`}</strong>{`.`}<br parentName="p"></br>{`
`}{`After last purchase TP `}<strong parentName="p">{`Grandport`}</strong>{`, go to `}<strong parentName="p">{`Loch of the Lost King`}</strong>{`.`}<br parentName="p"></br>{`
`}{`Pick `}<strong parentName="p">{`Wind L`}</strong>{` and `}<strong parentName="p">{`$30000`}</strong>{`.`}</p>
    <p>{`TP `}<strong parentName="p">{`Quarrycrest`}</strong>{`, run to `}<strong parentName="p">{`Bolderfall`}</strong>{`.`}</p>
    <h3 {...{
      "id": "therion-ch1"
    }}>{`Therion Ch.1`}</h3>
    <p>{`S&Q inside`}</p>
    <h4 {...{
      "id": "heathecote"
    }}>{`Heathecote`}</h4>
    <p>{`Thunder L + Thunder M`}</p>
    <p>{`Steal `}<strong parentName="p">{`Pom S`}</strong>{` & `}<strong parentName="p">{`Nourishing S`}</strong>{`.`}</p>
    <p>{`Get `}<strong parentName="p">{`Hunter Shrine`}</strong>{`, pick `}<strong parentName="p">{`Olive L`}</strong>{`, tag `}<strong parentName="p">{`Victor's Hollow`}</strong>{`.`}<br parentName="p"></br>{`
`}{`TP `}<strong parentName="p">{`Quarrycrest`}</strong></p>
    <h3 {...{
      "id": "tressa-ch2-continued"
    }}>{`Tressa Ch.2 Continued.`}</h3>
    <p>{`If battle outside Manse, kill with `}<strong parentName="p">{`Wind/Thunder L`}</strong>{` and S&Q inside Manse. Otherwise, don't S&Q in Manse and kill battle there with L Stone.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "equipment"
      }}>{`Equipment`}</h5>
      <ul>
        <li parentName="ul">{`Tressa: Remove Wolf Bow, Buckler`}</li>
        <li parentName="ul">{`(Primrose if she's LVL7, else Therion): Optimize`}</li>
      </ul>
      <h5 {...{
        "id": "jobs-1"
      }}>{`Jobs`}</h5>
      <ul>
        <li parentName="ul">{`Tressa: `}<strong parentName="li">{`Hunter`}</strong>{`, Leghold`}</li>
        <li parentName="ul">{`Primrose: `}<strong parentName="li">{`Warrior`}</strong>{`, (Incite if enough JP) + Thousand Spears`}</li>
        <li parentName="ul">{`Therion: Armor Corrosive, `}<strong parentName="li">{`Merchant`}</strong>{`, Hired Help`}</li>
      </ul>
      <h5 {...{
        "id": "inventory"
      }}>{`Inventory`}</h5>
      <ul>
        <li parentName="ul">{`Nourishing S Therion`}</li>
        <li parentName="ul">{`Grape all`}</li>
      </ul>
    </Menu>
    <h4 {...{
      "id": "omar"
    }}>{`Omar`}</h4>
    <h5 {...{
      "id": "turn-1"
    }}>{`Turn 1`}</h5>
    <p>{`L Stones`}</p>
    <h5 {...{
      "id": "turn-2"
    }}>{`Turn 2`}</h5>
    <ul>
      <li parentName="ul">{`Primrose: Thousand Spears`}</li>
      <li parentName="ul">{`Tressa: Defend / Pom M Merchant if Merchant 2 did Attack x2 T1`}</li>
      <li parentName="ul">{`Therion: Armor Corrosive`}</li>
    </ul>
    <h5 {...{
      "id": "turn-3"
    }}>{`Turn 3`}</h5>
    <ul>
      <li parentName="ul">{`Merchant: HHVx4`}</li>
      <li parentName="ul">{`Other: M Stone`}</li>
    </ul>
    <p>{`TP `}<strong parentName="p">{`Victor's Hollow`}</strong>{`.`}</p>
    <h3 {...{
      "id": "tressa-ch3"
    }}>{`Tressa Ch.3`}</h3>
    <p>{`Trigger cutscenes, buy shield.`}</p>
    <p>{`Finish quest. Go to Forbidden Grotto.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "equipment-1"
      }}>{`Equipment`}</h5>
      <p>{`If you gave Therion Hasty Helm unequip him & equip Hasty Helm to Primrose`}</p>
      <h5 {...{
        "id": "jobs-2"
      }}>{`Jobs`}</h5>
      <p>{`If you were short JP for Incite teach it now.`}</p>
    </Menu>
    <p>{`S&Q at first save inside Forbidden Grotto. Pick `}<strong parentName="p">{`$15000`}</strong>{`.`}</p>
    <h4 {...{
      "id": "venomtooth-tiger"
    }}>{`Venomtooth Tiger`}</h4>
    <blockquote>
      <p parentName="blockquote">{`There are 2 bonuses you can get here. You can do both if turn order allows.`}</p>
      <ul parentName="blockquote">
        <li parentName="ul">{`You can guarantee Collect if you have Therion before Tressa T2.`}</li>
        <li parentName="ul">{`You can save the Light L if you have Prim before Tressa T3.`}</li>
      </ul>
    </blockquote>
    <h5 {...{
      "id": "turn-1-1"
    }}>{`Turn 1`}</h5>
    <ul>
      <li parentName="ul">{`Tressa: Rain of Arrows`}</li>
      <li parentName="ul">{`Primrose: Defend`}</li>
      <li parentName="ul">{`Therion: Pom L Tressa`}</li>
    </ul>
    <h5 {...{
      "id": "turn-2-1"
    }}>{`Turn 2`}</h5>
    <ul>
      <li parentName="ul">{`Primrose: Thousand Spears`}</li>
      <li parentName="ul">{`Tressa: Collect x4`}</li>
      <li parentName="ul">{`Therion: Armor Corrosive`}</li>
    </ul>
    <h5 {...{
      "id": "turn-3-1"
    }}>{`Turn 3`}</h5>
    <ul>
      <li parentName="ul">{`Tressa: HHVx3-4`}</li>
      <li parentName="ul">{`Primrose: Light L / Pom Tressa if before her (saves Wind L)`}</li>
      <li parentName="ul">{`Therion: HHVx4`}</li>
    </ul>
    <p>{`Finish quest, TP `}<strong parentName="p">{`Grandport`}</strong>{`.`}</p>
    <h3 {...{
      "id": "tressa-ch4"
    }}>{`Tressa Ch.4`}</h3>
    <p>{`Go to shop.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "shop"
      }}>{`Shop`}</h5>
      <ul>
        <li parentName="ul">{`Sell Gold Items`}</li>
        <li parentName="ul">{`Sell Wolf Bow, Omar's Axe`}</li>
        <li parentName="ul">{`Sell Olive Ls`}</li>
      </ul>
      <p>{`Should have 88.2k`}</p>
    </Menu>
    <p>{`If you don't have a `}<strong parentName="p">{`Light/Wind L`}</strong>{`, pick the `}<strong parentName="p">{`Wind L`}</strong>{` in Sewers.`}</p>
    <blockquote>
      <p parentName="blockquote">{`Writing ideal fight. If people die, can try to Olive and go for break T2 or T3. Need all alive at start of turn to win. If non ideal fight, you can look for opporunities to boost Collect to increase chance of fast fight.`}</p>
    </blockquote>
    <h4 {...{
      "id": "esmeralda-96450hp"
    }}>{`Esmeralda 96450HP`}</h4>
    <blockquote>
      <p parentName="blockquote">{`Weak to Spear Axe Staff Wind Light (Initial) (4 Shield)`}<br parentName="p"></br>{`
`}{`Weak to Sword Bow Fire Lightning Wind (First Break) (6 Shield)`}<br parentName="p"></br>{`
`}{`Weak to Spear Dagger Ice Wind Dark`}</p>
    </blockquote>
    <h5 {...{
      "id": "turn-1-2"
    }}>{`Turn 1`}</h5>
    <ul>
      <li parentName="ul">{`Tressa: Light/Wind L`}</li>
      <li parentName="ul">{`Primrose: Thousand Spears x2`}</li>
      <li parentName="ul">{`Therion: Armor Corrosive`}</li>
    </ul>
    <h5 {...{
      "id": "turn-2-2"
    }}>{`Turn 2`}</h5>
    <ul>
      <li parentName="ul">{`Tressa & Therion: HHV x3`}</li>
      <li parentName="ul">{`Primrose: Incite`}</li>
    </ul>
    <h5 {...{
      "id": "turn-3-2"
    }}>{`Turn 3`}</h5>
    <ul>
      <li parentName="ul">{`Tressa: Leghold`}</li>
      <li parentName="ul">{`Therion: Olive`}</li>
    </ul>
    <h5 {...{
      "id": "turn-4"
    }}>{`Turn 4`}</h5>
    <ul>
      <li parentName="ul">{`Tressa: Rain of Arrows`}</li>
      <li parentName="ul">{`Primrose: Incite`}</li>
      <li parentName="ul">{`Therion: Collect (if it misses look below for backup)`}</li>
    </ul>
    <h5 {...{
      "id": "turn-5"
    }}>{`Turn 5`}</h5>
    <ul>
      <li parentName="ul">{`Tressa: Rain of Arrows`}</li>
      <li parentName="ul">{`Therion: Armor Corrosive`}</li>
    </ul>
    <h5 {...{
      "id": "turn-6"
    }}>{`Turn 6`}</h5>
    <ul>
      <li parentName="ul">{`Tressa & Therion: HHV x4`}</li>
    </ul>
    <hr></hr>
    <h4 {...{
      "id": "collect-miss-backup"
    }}>{`Collect Miss Backup`}</h4>
    <h5 {...{
      "id": "turn-5-1"
    }}>{`Turn 5`}</h5>
    <ul>
      <li parentName="ul">{`Tressa: Rain of Arrows`}</li>
      <li parentName="ul">{`Therion: Olive`}</li>
    </ul>
    <h5 {...{
      "id": "turn-6-1"
    }}>{`Turn 6`}</h5>
    <ul>
      <li parentName="ul">{`Merchant 1: Pom M Merchant 2 / Collect`}</li>
      <li parentName="ul">{`Merchant 2: Collect x3 / Collect`}</li>
      <li parentName="ul">{`Primrose: Incite`}</li>
    </ul>
    <h5 {...{
      "id": "turn-7"
    }}>{`Turn 7`}</h5>
    <ul>
      <li parentName="ul">{`Tressa: Leghold`}</li>
      <li parentName="ul">{`Therion: Olive`}</li>
    </ul>
    <h5 {...{
      "id": "turn-8"
    }}>{`Turn 8`}</h5>
    <ul>
      <li parentName="ul">{`Merchant 1: Attack x4`}</li>
      <li parentName="ul">{`Merchant 2: Attack x3`}</li>
      <li parentName="ul">{`Primrose: Incite`}</li>
    </ul>
    <h5 {...{
      "id": "turn-9"
    }}>{`Turn 9`}</h5>
    <ul>
      <li parentName="ul">{`Tressa: Tradewinds (break)`}</li>
      <li parentName="ul">{`Therion: Armor Corrosive`}</li>
    </ul>
    <h5 {...{
      "id": "turn-10"
    }}>{`Turn 10`}</h5>
    <ul>
      <li parentName="ul">{`Tressa & Therion: HHV x4`}</li>
    </ul>
    <p>{`Finish quest, skip cutscenes, `}<strong parentName="p">{`GG`}</strong></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      